if (!customElements.get("th-product-information")) {
  class thProductInformation extends HTMLElement {
    constructor() {
      super();
      
      this.ATC_PRICE_SELECTOR = "[data-atc-price]";
      this.ATC_PRICE_ORIGINAL_SELECTOR = "[data-atc-price-original]";
      this.SUBSCRIPTION_SUBTEXT_SELECTOR = "[data-subscription-subtext]";
      this.ONETIME_SUBTEXT_SELECTOR = "[data-onetime-subtext]";

      this.PRODUCT_ID = "[data-product-id]";
      this.BADGE_PRODUCT_ID = "[data-badge-product-id]";

      //recharge container element
      this.PRODUCT_INFORMATION_SELECTOR = "[data-th-product-information]";

      //Recharge elements
      this.RECHARGE_RADIO_SELECTOR = ".rc-radio";
      this.RECHARGE_SUB_DISCOUNT_SELECTOR = ".subscription-radio .discount-label";
      this.RECHARGE_ONETIME_SELECTOR = ".onetime-radio .discount-label"
      this.RECHARGE_SUB_LABEL_SELECTOR = ".rc-template__radio-group";
      this.RECHARGE_RADIO_INPUT_SELECTOR = ".rc-radio__input";
      this.RECHARGE_PRICE_SELECTOR = ".rc-radio__label .price-label";
      this.RECHARGE_RADIO_LABEL = ".rc-radio__label";
      this.RECHARGE_DISCOUNT_COUNTAINER = ".subscription-radio .rc-radio__label"
      this.mutation_target = 'rc-widget'

      //flag variable
      this.rechargeLoaded = false;
      
      //icon list element
      this.ICON_LIST_ITEM_SELECTOR = "[data-th-shipping-estimate]";


    }

    connectedCallback() {
      this.determineRechargeSource()
      setTimeout(() => {
        this.attachListeners();
        this.waitForElm();
        this.addIconListShippingText();        
      });
    }

    determineRechargeSource() {
      window.addEventListener("custom-recharge-widget", () => {
        this.RECHARGE_SUB_DISCOUNT_SELECTOR = ".rc_widget__option--subsave .rc-option__text";
        this.RECHARGE_ONETIME_SELECTOR = ".rc-option__onetime .rc-option__text"
        this.RECHARGE_PRICE_SELECTOR = ".rc-radio__label .rc_widget__price";
        this.RECHARGE_DISCOUNT_COUNTAINER = ".rc_widget__option--subsave .rc-radio__label"
        this.mutation_target = 'rc-container-wrapper'
      });
    }
  



    attachListeners() {
      window.addEventListener("th:recharge-ready", () => {
        this.addRechargeWidgetText();
        this.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach((input) => {
          input.addEventListener(
            "change",
            this.handleRechargeChange.bind(this, input)
          );
        });     
      });
    }

    waitForElm() {
      const element = this.querySelector(this.PRODUCT_INFORMATION_SELECTOR);
      if (!element) {return}
      //observer is necessary to detect when Recharge widget is 'initialized' - Injected Vue component
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (!mutation.target.firstElementChild) {
            return}

          if (mutation.target.firstElementChild.classList.contains(this.mutation_target)) {
            //custom event that's triggered when recharge widget initialized
            let selectedItem = ''
            document.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach(
              (radio) => {
                if (radio.checked) {
                  selectedItem = radio;
                  window.dispatchEvent(new CustomEvent('th:recharge-ready', { bubbles: true, detail: selectedItem }));
                  this.addComparePrice();
                  this.handleATCPrices();
                  this.toggleSubtext(radio);
                }
              }
            );
          }
        });
      });

      observer.observe(element, {
        childList: true,
        subtree: true,
      });
    }

    toggleSubtext(radio) {
      // Get all subscription and onetime subtext elements
      const subscriptionSubtexts = document.querySelectorAll(this.SUBSCRIPTION_SUBTEXT_SELECTOR);
      const onetimeSubtexts = document.querySelectorAll(this.ONETIME_SUBTEXT_SELECTOR);
      
      // Check if the radio is for subscription or onetime
      const isSubscription = radio.closest('.subscription-radio') || radio.closest('.rc_widget__option--subsave');
      
      // Toggle visibility based on which radio is selected
      subscriptionSubtexts.forEach(elem => {
        elem.style.display = isSubscription ? 'flex' : 'none';
      });
      
      onetimeSubtexts.forEach(elem => {
        elem.style.display = isSubscription ? 'none' : 'flex';
      });
    }

    handleATCPrices() {
      document.querySelectorAll(this.RECHARGE_RADIO_SELECTOR).forEach(
        (radio) => {
          let input = radio.querySelector(this.RECHARGE_RADIO_INPUT_SELECTOR);
          if (!input) {return}
          if (input.checked) {
            let atcPrice = document.querySelectorAll(this.ATC_PRICE_SELECTOR);
            let priceElem = radio.querySelector(this.RECHARGE_PRICE_SELECTOR);


            this.updateBadgePrice(priceElem.innerText);

            if (!priceElem) {return}
            atcPrice.forEach((elem) => {
              elem.innerText = priceElem.innerText;
            });
          }
        }
      );
    }

    addComparePrice() {
      this.comparePriceValue = this.getAttribute('data-selling-plan-compare-at-price');

      if (!this.comparePriceAdded) {
        if (this.comparePriceValue) {

          const radioLabels = document.querySelectorAll(this.RECHARGE_RADIO_LABEL);

          radioLabels.forEach((label) => {
            // Get the current price from the label
            const priceElement = label.querySelector(this.RECHARGE_PRICE_SELECTOR);
            if (!priceElement) return;
            
            // Parse both prices to numeric values for comparison
            const currentPrice = parseFloat(priceElement.innerText.replace(/[^0-9.]/g, ''));
            const comparePrice = parseFloat(this.comparePriceValue.replace(/[^0-9.]/g, ''));
            
            
            // Only add the compare price if it's greater than the current price
            if (comparePrice > currentPrice) {
              const comparePriceSpan = document.createElement('span');
              comparePriceSpan.classList.add('td-product-price__compare-price');
              
              comparePriceSpan.textContent = this.comparePriceValue;

              if (label.children.length >= 2) {
                label.insertBefore(comparePriceSpan, label.children[1]);
              } else {
                label.appendChild(comparePriceSpan);
              }
            }
          });
        }
        this.comparePriceAdded = true;
      }
    }

    updateBadgePrice(price) {
      if (this.comparePriceValue) {
        this.productId = document.querySelector(this.PRODUCT_ID).getAttribute("data-product-id")
        const parsedPrice = parseFloat(price.replace(/[^0-9.]/g, ''));
        const parsedComparePrice = parseFloat(this.comparePriceValue.replace(/[^0-9.]/g, ''));
        const savings = parsedComparePrice - parsedPrice;
      
        if (this.productId && parsedPrice && parsedComparePrice) {
          document.querySelectorAll(this.BADGE_PRODUCT_ID).forEach((element) => {
            this.badgeProductId = element.getAttribute("data-badge-product-id")
            if (this.badgeProductId == this.productId) {
              
              // If compare price is higher than current price, show savings
              if (parsedComparePrice > parsedPrice) {
                element.style.display = ""; // Reset display style
                element.textContent = "Save $" + savings.toFixed(0);
              } 
              // If prices are the same, hide the badge
              else {
                element.style.display = "none";
              }
            }
          });
        }
      }
    }

    handleRechargeChange() {
      //custom event that's triggered when recharge widget is changed
      let selectedItem = ''
      document.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach(
        (radio) => {
          if (radio.checked) {
            selectedItem = radio;
            window.dispatchEvent(new CustomEvent('th:recharge-change', { bubbles: true, detail: selectedItem }));
            this.handleATCPrices();
            this.toggleSubtext(radio);
          }
        }
      );
    }

    addIconListShippingText() {
      let estimatedDate = '';
      this.querySelectorAll(this.ICON_LIST_ITEM_SELECTOR).forEach((item) => {
        function getMonthName(monthNumber) {
          const date = new Date();
          date.setMonth(monthNumber - 1);
          return date.toLocaleString('en-US', { month: 'long' });
        }

        const shippingDays = parseInt(item.dataset.thShippingEstimate);
        let date = new Date();
        date.setDate(date.getDate() + shippingDays);
        estimatedDate = `${getMonthName(date.getMonth() + 1)} ${date.getDate()}`;
        if (!estimatedDate) {return}
        item.innerHTML = `
        <span class="th-shipping-estimate">${estimatedDate}</span>
        `
      });
    }

    addRechargeWidgetText() {
      if (!this.rechargeLoaded) {
        const subLabel = this.querySelector(this.RECHARGE_SUB_DISCOUNT_SELECTOR);
        const newSubLabel = this.dataset.rechargeNewSubLabel;
        const checkmarkIcon = this.dataset.rechargeCheckmarkIcon;
        const discountContainer = this.querySelector(this.RECHARGE_DISCOUNT_COUNTAINER);
    
        const subBullets = [
          { text: this.dataset.rechargeSubBulletOne, image: checkmarkIcon },
          { text: this.dataset.rechargeSubBulletTwo, image: checkmarkIcon },
          { text: this.dataset.rechargeSubBulletThree, image: checkmarkIcon },
          { text: this.dataset.rechargeSubBulletFour, image: checkmarkIcon },
        ];
    
        const oneTimeLabel = this.querySelector(this.RECHARGE_ONETIME_SELECTOR);
        const newOnetimeLabel = this.dataset.rechargeNewOnetimeLabel;
    
        const updateLabelText = (label, newText) => {
          if (newText && label) {
            label.textContent = newText;
          }
        };
    
        const addBulletsToLabel = (label, bullets, textClassName, imageClassName) => {
          if (label) {
            bullets.forEach(bullet => {
              if (bullet.text && bullet.image) {
                let bulletContainer = document.createElement('div');
                bulletContainer.classList.add('td-bullet-container');
                
                if (bullet.image) {
                  let imageElem = document.createElement('img');
                  imageElem.classList.add(imageClassName);
                  imageElem.src = bullet.image;
                  bulletContainer.appendChild(imageElem);
                }
                if (bullet.text) {
                  let bulletElem = document.createElement('span');
                  bulletElem.classList.add(textClassName);
                  bulletElem.innerHTML = bullet.text;
                  bulletContainer.appendChild(bulletElem);
                }
    
                label.appendChild(bulletContainer);
              }
            });
          }
        };
    
        const createDropdown = () => {
          const dropdown = document.createElement('select');
          dropdown.classList.add('td-delivery-dropdown');
    
          const items = document.querySelectorAll('.td-pps-item-container');
          let matched = false;
          let hasValidOptions = false; // flag to check if there's at least one valid option
    
          items.forEach(item => {
            const deliveryText = item.getAttribute('data-delivery-text');
            if (deliveryText) { // check if data-delivery-text isn't null
              hasValidOptions = true; // set flag to true if there's at least one valid option
              const option = document.createElement('option');
              option.value = item.getAttribute('data-product-item-url');
              option.textContent = deliveryText;
              dropdown.appendChild(option);
    
              if (item.getAttribute('data-product-item-id') === item.getAttribute('data-product-id') && !matched) {
                option.selected = true;
                matched = true;
              }
            }
          });
    
          if (hasValidOptions) { // only add event listener and return dropdown if there's at least one valid option
            dropdown.addEventListener('change', (event) => {
              const selectedUrl = event.target.value;
              if (selectedUrl) {
                window.location.href = selectedUrl;
              }
            });
    
            return dropdown;
          } else {
            return null; // return null if no valid options
          }
        };
    
        updateLabelText(subLabel, newSubLabel);
        updateLabelText(oneTimeLabel, newOnetimeLabel);
    
        addBulletsToLabel(discountContainer, subBullets, 'td-sub-text', 'td-sub-image');
    
        // Commented out createDropdown. Haven't deleted incase they change their minds

        // const dropdown = createDropdown();
        // if (dropdown) {
        //   const firstBulletContainer = discountContainer.querySelector('.td-bullet-container');
        //   if (firstBulletContainer) {
        //     discountContainer.insertBefore(dropdown, firstBulletContainer);
        //   } else {
        //     discountContainer.appendChild(dropdown);
        //   }
        // }
    
        this.rechargeLoaded = true;
      }
    }
  }

  customElements.define("th-product-information", thProductInformation);
}
